import { wrap_elements, create_div, get_el } from 'js/utils';

const default_swiper_settings = {
    autoplay : {
        delay: 5000,
    },
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    loop: true,
}

export default class Swiper_Mobile {
    
    constructor(args = {}){
        
        this.args = args;
        
        this.container = get_el(args.container);
        if( !this.container ) return;
        
        this.items = get_el(args.items, true, this.container);
        if( !this.items ) return;

        if( this.container.swiper_mobile_init ) return; 
        this.container.swiper_mobile_init = true;

        setTimeout(()=>this.init_swiper(), 0);
    }

    init_swiper(){
        
        this.container.classList.add('swiper');

        // add swiper html
        wrap_elements({
            render: this.container,
            wrapper_class: 'swiper-wrapper',
            items: this.items,
            item_class: 'swiper-slide',
        });

        this.swiper_settings = this.args.swiper_settings ?? default_swiper_settings;
        
        this.init_nav();

        this.apply_extended_swiper_settings();
        
        this.swiper = new Swiper(this.container, this.swiper_settings);
    }

    apply_extended_swiper_settings(){
        if( !this.args.extend_swiper_settings ) return;
        for(const key in this.args.extend_swiper_settings ) {
            this.swiper_settings[key] = this.args.extend_swiper_settings[key];
        }
    }

    init_nav(){
        
        if( typeof this.args.arrows === 'undefined'
            && typeof this.args.bullets === 'undefined' ) {
            return;
        }

        this.nav = this.args.nav ?? {}
        
        this.nav.display = this.nav.display ?? 'default';
        this.nav.position = this.nav.position ?? 'after';
        
        this.nav.container = create_div('nav_container');
        
        if( this.nav.position == 'before' ) {
            this.container.before(this.nav.container);
        }
        else {
            this.container.after(this.nav.container);
        }
        
        this.arrows_init();
        this.bullets_init();
    }

    arrows_init(){

        if( typeof this.args.arrows === 'undefined' ) return;
        if( !this.args.arrows ) return;

        const arrows = create_div('button_arrows', this.nav.container);

        const prev = create_div('prev', arrows);
        const next = create_div('next', arrows);

        this.swiper_settings.navigation = {
            prevEl: prev,
            nextEl: next,
        }
    }

    bullets_init(){

        if( typeof this.args.bullets === 'undefined' ) return;
        if( !this.args.bullets ) return;
        
        const bullets = create_div('swiper-pagination');
        
        if( this.nav.display === 'in-between'
            && typeof this.swiper_settings.navigation !== 'undefined' ) {
            this.swiper_settings.navigation.nextEl.before(bullets);
        }
        else {
            this.nav.container.after(bullets);
        }
        
        this.swiper_settings.pagination = {
            clickable: true,
            el: bullets,
        }
    }
    
}